import { Divider as MantineDivider } from '@mantine/core';

export const Divider = MantineDivider.extend({});
